export default __webpack_public_path__ + "static/media/central_andes_2_19.8cab91c6.JPG";